import { render, staticRenderFns } from "./OntologyListView.vue?vue&type=template&id=1549ca70&"
import script from "./OntologyListView.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OntologyListView.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OntologyListView.vue?vue&type=style&index=0&id=1549ca70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports